export enum QueueRequestType {
  DOCUMENTS_FILL = 'DOCUMENTS_FILL',
  CHECKLIST_GENERATION = 'CHECKLIST_GENERATION',
  IMAGES_TRANSFORM = 'IMAGES_TRANSFORM',
  IMAGES_TRANSFORM_AND_MERGE = 'IMAGES_TRANSFORM_AND_MERGE',
  MERGING_PDFS = 'MERGING_PDFS',
  SENDING_TO_MOS = 'SENDING_TO_MOS',
}

export enum PdfGenerationType {
  FULL_PROCESS = 'FULL_PROCESS',
  CHECKLIST = 'CHECKLIST',
}

export enum GenerationStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  FINISHED = 'FINISHED',
  ERROR = 'ERROR',
  IDLE = 'IDLE',
}

export const enum ExternalSystemName {
  MOS = 'MOS',
}

export interface JobGenerationOpts {
  withExternalSystem: boolean;
  externalSystemName: ExternalSystemName;
  withCredentials?: ExternalSystemCredentials;
}

export interface JobGenerationStatus {
  jobType: QueueRequestType;
  status: GenerationStatus;
  startedAt?: string;
  finishedAt?: string;
  error?: any;
}
export interface PdfsGenerationJob {
  userProcessId: string;
  wholeJobCompleted: boolean;
  [QueueRequestType.DOCUMENTS_FILL]?: JobGenerationStatus;
  [QueueRequestType.IMAGES_TRANSFORM]?: JobGenerationStatus;
  [QueueRequestType.MERGING_PDFS]?: JobGenerationStatus;
}

export interface DocumentsGenerationStatus {
  availableStatuses: JobGenerationStatus[];
  allRequiredFinished: boolean;
}

export interface ExternalSystemCredentials {
  email: string;
  password: string;
}

export interface SendToMosRequestOpts {
  userId: string;
  userProcessId: string;
  withCredentials?: ExternalSystemCredentials;
}

export interface PdfGenerationTaskView {
  type: QueueRequestType;
  status: GenerationStatus;
  startedAt: string | null;
  finishedAt: string | null;
  error: any | null;
  result: any | null;
}

export interface PdfGenerationView {
  id: string;
  type: PdfGenerationType;
  status: GenerationStatus;
  requestedBy: { id: string; name: string } | null;
  createdAt: string;
  finishedAt: string | null;
  opts: unknown | null;
  tasks: PdfGenerationTaskView[];
}

export interface PdfGenerationsOverview {
  lastFullProcessGeneration: PdfGenerationView | null;
  lastChecklistGeneration: PdfGenerationView | null;
  generations: PdfGenerationView[];
}

export interface PdfGenerationCurrentProgress {
  isChecklistGenerationInProgress: boolean;
  isDocumentsGenerationInProgress: boolean;
  isAnyGenerationJobInProgress: boolean;
}
